export const heroData = {
  tagline: "全网独家爆料",
  titleLine1: "51吃瓜黑料",
  titleLine2: "吃瓜不打烊",
  titleLine3: "黑料视频入口",
  subtitle: "覆盖网曝门、明星爆料、网红塌房、博主反差记录，网站不打烊更新",
  ctaText: "立即吃瓜",
  ctaLink: "#hot-articles",
};

export const hotArticles = [
  {
    id: "article-1",
    title: "某千万粉网红深夜直播翻车，背后金主身份遭实锤曝光",
    excerpt: "据知情人士透露，该网红与多位娱乐圈资本大佬关系密切，直播翻车后大量黑料被网友扒出，涉及合同欺诈与虚假人设。",
    category: "网红塌房",
    categorySlug: "influencer-scandal",
    imageUrl: "https://readdy.ai/api/search-image?query=Dark%20moody%20cinematic%20scene%20of%20a%20streaming%20studio%20with%20dramatic%20red%20and%20amber%20lighting%2C%20abstract%20silhouette%20of%20a%20person%20at%20a%20desk%20with%20multiple%20screens%2C%20tense%20atmosphere%2C%20warm%20dark%20tones%2C%20editorial%20photography%20style%20with%20soft%20shadows%20and%20cinematic%20composition&width=800&height=600&seq=hot-article-01&orientation=landscape",
    views: "128.6万",
    date: "2026-07-06",
    tag: "独家爆料",
  },
  {
    id: "article-2",
    title: "某顶流男星夜店私密视频外泄，工作室紧急发声明否认",
    excerpt: "视频中疑似该男星与多名女子亲密互动，画面尺度极大。粉丝后援会已组织大规模控评行动，但网友已截图保存。",
    category: "明星黑料",
    categorySlug: "celebrity-scandal",
    imageUrl: "https://readdy.ai/api/search-image?query=Moody%20nightclub%20interior%20with%20deep%20amber%20and%20crimson%20neon%20lights%2C%20abstract%20blurred%20figures%20in%20the%20background%2C%20dramatic%20atmosphere%2C%20warm%20dark%20tones%2C%20cinematic%20photography%20with%20lens%20flare%20and%20soft%20focus%2C%20editorial%20style&width=800&height=600&seq=hot-article-02&orientation=landscape",
    views: "256.3万",
    date: "2026-07-06",
    tag: "网曝门",
  },
  {
    id: "article-3",
    title: "知名美食博主被曝人设造假，私底下竟靠代拍年入千万",
    excerpt: "该博主以'真实的日常生活'走红，却被前助理爆出所有内容均有剧本。其真实身份为某MCN机构幕后股东。",
    category: "博主反差",
    categorySlug: "blogger-contrast",
    imageUrl: "https://readdy.ai/api/search-image?query=Dark%20cinematic%20scene%20of%20a%20modern%20kitchen%20studio%20setup%20with%20professional%20lighting%20equipment%2C%20warm%20amber%20tones%2C%20dramatic%20shadows%2C%20abstract%20composition%20with%20food%20props%20scattered%2C%20editorial%20photography%20style%2C%20tense%20atmosphere&width=800&height=600&seq=hot-article-03&orientation=landscape",
    views: "89.2万",
    date: "2026-07-05",
    tag: "反差记录",
  },
  {
    id: "article-4",
    title: "某女团成员私下吸烟喝酒照曝光，清纯人设彻底崩塌",
    excerpt: "照片拍摄于某私人聚会，该成员与多名男性友人举止亲密。经纪公司已宣布暂停其所有演艺活动。",
    category: "明星黑料",
    categorySlug: "celebrity-scandal",
    imageUrl: "https://readdy.ai/api/search-image?query=Dark%20atmospheric%20private%20party%20scene%20with%20warm%20candlelight%20and%20deep%20shadows%2C%20abstract%20silhouettes%20of%20people%20socializing%2C%20burgundy%20and%20amber%20color%20palette%2C%20cinematic%20moody%20photography%20with%20dramatic%20lighting%2C%20editorial%20style&width=800&height=600&seq=hot-article-04&orientation=landscape",
    views: "342.1万",
    date: "2026-07-05",
    tag: "独家爆料",
  },
  {
    id: "article-5",
    title: "某直播平台头部主播涉嫌数据造假，后台截图被内部员工泄露",
    excerpt: "截图显示该主播直播间真实在线人数不足显示的十分之一，大量弹幕由机器人自动发送。平台方暂未回应。",
    category: "网红塌房",
    categorySlug: "influencer-scandal",
    imageUrl: "https://readdy.ai/api/search-image?query=Dark%20moody%20computer%20screen%20in%20a%20dimly%20lit%20room%2C%20abstract%20data%20charts%20and%20numbers%20glowing%20in%20amber%20light%2C%20warm%20dark%20tones%2C%20cinematic%20atmosphere%20with%20deep%20shadows%2C%20editorial%20photography%20style%2C%20mysterious%20composition&width=800&height=600&seq=hot-article-05&orientation=landscape",
    views: "176.8万",
    date: "2026-07-04",
    tag: "网曝门",
  },
  {
    id: "article-6",
    title: "某知名夫妻档博主被爆已离婚半年，共同账号实为商业合约",
    excerpt: "据圈内人士透露，二人早在去年底就已办理离婚手续，但因广告合约未到期一直维持假恩爱形象。",
    category: "博主反差",
    categorySlug: "blogger-contrast",
    imageUrl: "https://readdy.ai/api/search-image?query=Dark%20cinematic%20scene%20of%20two%20separated%20figures%20in%20a%20luxurious%20modern%20living%20room%2C%20warm%20amber%20lighting%20with%20deep%20shadows%2C%20emotional%20distance%20atmosphere%2C%20editorial%20photography%20style%2C%20moody%20composition%20with%20dramatic%20contrast&width=800&height=600&seq=hot-article-06&orientation=landscape",
    views: "203.5万",
    date: "2026-07-04",
    tag: "反差记录",
  },
];

export const categories = [
  {
    slug: "influencer-scandal",
    name: "网红塌房",
    description: "跟踪记录每一位网红的至暗时刻，从巅峰到谷底的全过程揭秘",
    icon: "ri-camera-off-line",
  },
  {
    slug: "celebrity-scandal",
    name: "明星黑料",
    description: "娱乐圈明星不为人知的另一面，独家爆料与深度调查报道",
    icon: "ri-star-off-line",
  },
  {
    slug: "blogger-contrast",
    name: "博主反差",
    description: "揭露博主镜头前后的真实反差，人设与现实的巨大鸿沟",
    icon: "ri-contrast-2-line",
  },
  {
    slug: "exposure-gate",
    name: "网曝门事件",
    description: "全网最劲爆的曝光事件汇总，第一时间获取最新爆料资讯",
    icon: "ri-alert-line",
  },
  {
    slug: "daily-contest",
    name: "每日大赛",
    description: "每日精选最热门的话题大赛现场，精彩内容持续更新中",
    icon: "ri-live-line",
  },
  {
    slug: "video-entry",
    name: "视频入口",
    description: "高清吃瓜视频在线观看，还原每一个爆料的真实现场画面",
    icon: "ri-video-line",
  },
];

export const testimonials = [
  {
    id: "t1",
    quote: "自从关注了51吃瓜黑料，每天第一件事就是打开看看有没有新瓜。更新速度太快了，比其他平台快了好几个小时！信息量巨大，每次看完都意犹未尽。",
    author: "资深吃瓜群众",
    role: "忠实用户·关注2年",
    imageUrl: "https://readdy.ai/api/search-image?query=Warm%20toned%20abstract%20portrait%20of%20a%20community%20of%20people%20gathered%20together%2C%20soft%20amber%20and%20cream%20colors%2C%20minimalist%20illustration%20style%2C%20unity%20and%20connection%20theme%2C%20clean%20simple%20background%2C%20editorial%20aesthetic&width=600&height=600&seq=testimonial-01&orientation=squarish",
  },
  {
    id: "t2",
    quote: "这个网站真的太敢爆了！很多在其他平台看不到的内容这里都有，而且整理得很清楚，按分类查找特别方便。已经推荐给身边所有朋友了。",
    author: "八卦小能手",
    role: "活跃用户·关注1年",
    imageUrl: "https://readdy.ai/api/search-image?query=Warm%20toned%20abstract%20art%20of%20diverse%20group%20of%20people%20sharing%20news%20together%2C%20soft%20amber%20and%20cream%20colors%2C%20minimalist%20illustration%20style%2C%20community%20vibe%2C%20clean%20simple%20background%2C%20editorial%20aesthetic&width=600&height=600&seq=testimonial-02&orientation=squarish",
  },
  {
    id: "t3",
    quote: "作为一个自媒体人，51吃瓜黑料是我的选题宝库。这里的爆料信息又快又准，帮我抓住了好几次热点流量。内容质量和更新频率都是一流的。",
    author: "自媒体运营者",
    role: "行业用户·关注3年",
    imageUrl: "https://readdy.ai/api/search-image?query=Warm%20toned%20abstract%20illustration%20of%20people%20collaborating%20and%20sharing%20ideas%2C%20soft%20amber%20and%20cream%20colors%2C%20minimalist%20style%2C%20teamwork%20theme%2C%20clean%20simple%20background%2C%20editorial%20aesthetic&width=600&height=600&seq=testimonial-03&orientation=squarish",
  },
];

export const ctaData = {
  leftTitle: "下载APP",
  leftTitle2: "吃瓜不迷路",
  leftTitle3: "爆料快人一步",
  leftTag: "随时随地掌握全网黑料",
  rightTitle: "随时随地掌握全网黑料",
  rightDescription: "关注51吃瓜黑料，第一时间获取网红塌房、明星爆料、博主反差等最新资讯。网站不打烊，吃瓜不停歇。",
  rightButtonText: "立即访问",
  leftImageUrl: "https://readdy.ai/api/search-image?query=Warm%20toned%20abstract%20digital%20art%20of%20a%20modern%20smartphone%20displaying%20news%20content%20with%20amber%20and%20cream%20gradients%2C%20minimalist%20design%20aesthetic%2C%20clean%20simple%20composition%2C%20editorial%20style%2C%20soft%20shadows%2C%20elegant%20atmosphere&width=800&height=1000&seq=cta-section-01&orientation=portrait",
};